
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function LendingSection() {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.REACT_APP_NAVIGATE('/lending');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <section className="relative py-20 bg-gradient-to-br from-blue-900 via-gray-900 to-cyan-900 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/90 via-gray-900/85 to-cyan-900/90"></div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20 z-0">
        <div className="absolute top-20 right-10 w-72 h-72 bg-blue-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('lending.hero.title')}
          </h2>
          <p className="text-2xl text-gray-300 mb-8">
            {t('lending.hero.subtitle')}
          </p>
        </div>

        {/* Lending Plans */}
        <div className="mb-12">
          <h3 className="text-3xl md:text-4xl font-bold text-white text-center mb-4">
            {t('lending.plans.title')}
          </h3>
          <p className="text-xl text-gray-300 text-center mb-12">
            {t('lending.plans.subtitle')}
          </p>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Standard Plan */}
            <div className="bg-gradient-to-br from-blue-900/40 to-cyan-900/40 border-2 border-blue-500 rounded-2xl p-8 hover:scale-105 transition-transform">
              <div className="bg-blue-600 text-white text-center py-3 rounded-lg mb-6 font-bold text-lg">
                {t('lending.plans.standard.period')}
              </div>
              <h3 className="text-2xl font-bold text-white text-center mb-4">
                {t('lending.plans.standard.name')}
              </h3>
              <p className="text-gray-300 text-center mb-6 leading-relaxed">
                {t('lending.plans.standard.desc')}
              </p>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center mb-6">
                <div className="flex items-center justify-center gap-2">
                  <span className="text-2xl text-white">{t('lending.plans.annual')}</span>
                  <span className="text-6xl font-bold text-blue-400">10</span>
                  <span className="text-2xl text-white">%</span>
                </div>
              </div>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-400 text-xl mr-2 mt-1"></i>
                  <span>{t('lending.plans.standard.feature1')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-400 text-xl mr-2 mt-1"></i>
                  <span>{t('lending.plans.standard.feature2')}</span>
                </li>
              </ul>
            </div>

            {/* Extra Plan */}
            <div className="bg-gradient-to-br from-yellow-900/40 to-orange-900/40 border-2 border-yellow-500 rounded-2xl p-8 hover:scale-105 transition-transform relative">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-500 text-gray-900 px-6 py-2 rounded-full font-bold text-sm">
                {t('lending.plans.recommended')}
              </div>
              <div className="bg-yellow-600 text-white text-center py-3 rounded-lg mb-6 font-bold text-lg">
                {t('lending.plans.extra.period')}
              </div>
              <h3 className="text-2xl font-bold text-white text-center mb-4">
                {t('lending.plans.extra.name')}
              </h3>
              <p className="text-gray-300 text-center mb-6 leading-relaxed">
                {t('lending.plans.extra.desc')}
              </p>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center mb-6">
                <div className="flex items-center justify-center gap-2">
                  <span className="text-2xl text-white">{t('lending.plans.annual')}</span>
                  <span className="text-6xl font-bold text-yellow-400">13.2</span>
                  <span className="text-2xl text-white">%</span>
                </div>
              </div>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-400 text-xl mr-2 mt-1"></i>
                  <span>{t('lending.plans.extra.feature1')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-400 text-xl mr-2 mt-1"></i>
                  <span>{t('lending.plans.extra.feature2')}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Button
            onClick={handleLinkClick}
            className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white px-8 py-4 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
          >
            {t('lending.hero.cta.learn')}
          </Button>
        </div>
      </div>
    </section>
  );
}
